/*
 | =================================================
 | This File is for member hub vaults state handling
 | =================================================
 */

const state = {
  vaultFormData: {},
  products: [],
  showEmptyProducts:false,
  product: {},
  lifeProduct: {},
  archivedProducts: [],
  forwardedEmails: [],
  forwardedBills: [],
  forwardedFiles: [],
  forwardedBillsLoaded: false,
  // Draft vaults found by scanning the member's connected inboxes (raw
  // GET /vaults/drafts items).
  importedBills: [],
  importedBillsLoaded: false,
  // Energy bill history per vault product id (raw API items), fetched once.
  billHistory: {},
  // Energy bill detail per vault product id, then bill id (raw API items),
  // fetched once per bill as bill details shows it.
  billDetails: {},
  // Bill detail requests that failed, per vault product id then bill id.
  billDetailFailed: {},
  // CDR consent per vault product id (raw consent, or null when none), fetched once.
  cdrConsent: {},
  // Vault product ids whose bill history came from CDR (their bill details use
  // the CDR endpoint).
  cdrBillVaults: {},
  // Bills History summary per vault product id, as the API sends it
  // ({count, periodMonths}; CDR only — email history derives it from the list).
  billHistorySummary: {},
  vaultLoader: true,
  setManualHealthVaultActive: false,
  // When `product` was last set from the API - see isProductStale (CLUB-899)
  product_fetched_at: null,
  isSyncing: false,
  inlineEditParams: {},
  isInlineEdit: false,
  leadAddress: {},
  verticals: import.meta.client && localStorage.getItem('verticals')
    ? JSON.parse(localStorage.getItem('verticals'))
    : [],
  smartBillUpload:{
    failedFiles:[],
    uploadedFiles:[],
    storageConsent: false
  }
}

export default () => {
  return state
}
